<template>
    <div class="door-check-add">
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">
                    <h2 class="page-header-title">
                        <router-link to="/door-installation-reports">
                        Door Installation Reports</router-link>
                        &raquo;
                        <span v-if="isEdit">
                        <router-link :to="{ name: 'door-installation-report-view', params: {action: 'view', id: report.site_door_installation_report_id} }">
                            {{ report.job_number }} | {{ report.prepared_for }}
                        </router-link>
                             &raquo;
                            </span>
                        <span v-if="isEdit">
                                  Edit Door Installation Report</span><span v-else>  Add Door Installation Report</span></h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <input
                        name="site_door_installation_report_id"
                        type="hidden"
                        v-model="report.site_door_installation_report_id"
                >
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">

                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Report Details</h2>
                                </div>
                                <div class="widget-body">
                                    <div class="form-group row d-flex align-items-center required" v-if="report.use_bm_trada_template">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('sequential_reference_number')]"
                                               for="sequential_reference_number">Sequential Reference Number</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="sequential_reference_number"
                                                    :class="['form-control', getFieldClasses('sequential_reference_number')]"
                                                    maxlength="255"
                                                    id="sequential_reference_number"
                                                    v-model="report.sequential_reference_number"
                                                    @blur="onFieldBlur('sequential_reference_number')"
                                            />
                                            <div v-if="isErrorField('sequential_reference_number')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('job_number')]"
                                               for="job_number">Installation Job Reference</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="job_number"
                                                    :class="['form-control', getFieldClasses('job_number')]"
                                                    maxlength="255"
                                                    id="job_number"
                                                    v-model="report.job_number"
                                                    @blur="onFieldBlur('job_number')"
                                            />
                                            <div v-if="isErrorField('job_number')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('prepared_for')]"
                                                for="prepared_for">Prepared for</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="prepared_for"
                                                    :class="['form-control', getFieldClasses('prepared_for')]"
                                                    maxlength="255"
                                                    id="prepared_for"
                                                    v-model="report.prepared_for"
                                                    @blur="onFieldBlur('prepared_for')"
                                            />
                                            <div v-if="isErrorField('prepared_for')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>
                                    <div class="form-group row d-flex align-items-center  required">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('site_address')]"
                                               for="client-site">Site Address</label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    type="text"
                                                    name="site_address"
                                                    :class="['form-control', getFieldClasses('site_address')]"
                                                    v-model="report.site_address"
                                                    id="site_address"
                                                    @blur="onFieldBlur('site_address')"
                                            /></div>
                                        <div v-if="isErrorField('site_address')" class="invalid-feedback">This field is required</div>
                                    </div>
                                    
                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="date-of-inspection">
                                            Date Of Issue
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="report.date_of_issue"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="date_of_issue"
                                            ></datepicker>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center mb-5 required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <p>Is this being carried out under BM Trada?</p>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input
                                                        type="radio"
                                                        :value="true"
                                                        id="ubt-yes"
                                                        name="use_bm_trada_template"
                                                        class="button-positive"
                                                        v-model="report.use_bm_trada_template"
                                                    >
                                                    <label for="ubt-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input
                                                        type="radio"
                                                        :value="false"
                                                        id="ubt-no"
                                                        name="use_bm_trada_template"
                                                        class="button-negative"
                                                        v-model="report.use_bm_trada_template"
                                                    >
                                                    <label for="ubt-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>

    </div>
</template>

<style>
    .form-control {
        background: #fff !important;
    }
    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>

<script>
    import { required, requiredIf } from 'vuelidate/lib/validators'

    import moment from 'moment'
    import Datepicker from 'vuejs-datepicker';

    export default {
        data() {
            return {
                isEdit: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                report: {
                    site_door_installation_report_id: Math.floor(new Date().getTime() / 1000),
                    door_installation_report_id: null,
                    sequential_reference_number: null,
                    job_number: null,
                    date_of_issue: new Date(),
                    prepared_for: null,
                    site_address: null,
                    use_bm_trada_template: false,
                    pdf_link: null,
                    report_version: null
                }
            }
        },
        validations: {
            report: {
                sequential_reference_number: { 
                    required: requiredIf(function (nestedModel) {
                        return this.report.use_bm_trada_template;
                    })
                 },
                job_number: { required },
                prepared_for: { required },
                site_address: { required },
            },
        },
        methods: {
            getReport() {
                var vmt = this;
                this.getDb(function onConnected(db) {

                    var vm = vmt;
                    try {
                        var reportId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_installation_reports').objectStore('door_installation_reports');
                        var storeRequest = objectStore.get(reportId);

                        storeRequest.onsuccess = function(event) {
                            vm.report = storeRequest.result;
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vm = this
                let request = new Promise((resolve, reject) => {
                    vm.getDb(function onConnectedGetDoorSets(db) {
                        var putRequest = db.transaction('door_installation_reports', 'readwrite')
                            .objectStore('door_installation_reports').put({
                                site_door_installation_report_id: vm.report.site_door_installation_report_id,
                                door_installation_report_id: vm.report.door_installation_report_id,
                                sequential_reference_number: vm.report.sequential_reference_number,
                                job_number: vm.report.job_number,
                                date_of_issue: vm.report.date_of_issue,
                                prepared_for: vm.report.prepared_for,
                                site_address: vm.report.site_address,
                                use_bm_trada_template: vm.report.use_bm_trada_template,
                                pdf_link: vm.report.pdf_link,
                                report_version: typeof vm.report.report_version == 'undefined' ? null : vm.report.report_version,
                            });
                        putRequest.onsuccess = function(event) {
                            vm.submitSuccess({
                                success: true,
                                door_installation_report_id: putRequest.result,
                            })
                        }
                        putRequest.onerror = function(event) {
                            alert("Unable to add data ");
                        }

                    })
                });
            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'door-installation-report-view', params: {action: 'view', id: response.door_installation_report_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.report)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.report[field]) {
                    return this.$v.report[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
            reload() {
                window.location = '';
            },
        },
        components: {
            Datepicker,
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDIR') === -1) {
                this.$router.push('/');
                return;
            }

            let reportId = this.$route.params.id;
            if (reportId) {
                this.isEdit = true;
                this.getReport();
            }
        },

    }
</script>